import { get, post, patch } from 'libs/fetch';
import { Prefecture } from 'libs/apiClient/prefectures';

export const indexPath = 'api/v1/areas';

/* get request */
export type Area = {
  id: number;
  name: string;
  prefectures: Prefecture[];
}


// TODO: deplicated
export const index = async (
  callback: (responseData: Area[]) => void,
  forbiddenCallback?: () => void,
) => {
  const res = await get('api/v1/areas');
  const body = await res.json();

  if (res.status === 200) {
    const responseData: Area[] = body.areas;
    callback(responseData)
  } else if (res.status == 403) {
    forbiddenCallback !== undefined && forbiddenCallback();
  }
}

export const show = async (
  id: string,
  callback: (responseData: Area) => void,
  forbiddenCallback?: () => void,
) => {
  const res = await get(`api/v1/areas/${id}`);
  const body = await res.json();

  if (res.status === 200) {
    const responseData: Area = body.area;
    callback(responseData)
  } else if (res.status == 403) {
    forbiddenCallback !== undefined && forbiddenCallback();
  }
  
}

/* post request */
export type CreateData = {
  name: string;
  prefectureIds: number[];
}

export type CreateResponse = {
  id: number;
}

export type CreateErrors = {
  name: string[];
  prefectureIds: string[];
}

export const create = async (
  data: CreateData,
  callback: (responseData: CreateResponse) => void,
  errCallback: (error: CreateErrors) => void,
  forbiddenCallback?: () => void,
) => {
  const res = await post('api/v1/admin/areas', { area: data });
  const body = await res.json();

  if (res.status == 200) {
    const responseData: CreateResponse = body.area;
    callback(responseData)
  } else if (res.status == 400) {
    const errors: CreateErrors = body.errors;
    errCallback(errors);
  } else if (res.status === 403) {
    forbiddenCallback != undefined && forbiddenCallback();
  }
}

/* patch request */
export type UpdateData = {
  name: string;
  prefectureIds: number[];
}

export type UpdateResponse = {
  id: number;
}

export type UpdateErrors = {
  name: string[];
  prefectureIds: string[];
}

export const update = async (
  id: number | string,
  data: UpdateData,
  callback: (responseData: UpdateResponse) => void,
  errCallback: (err: UpdateErrors) => void,
  forbiddenCallback?: () => void,
) => {
  const res = await patch(`api/v1/admin/areas/${id}`, { area: data });
  const body = await res.json();

  if (res.status == 200) {
    const responseData: UpdateResponse = body.area;
    callback(responseData)
  } else if (res.status == 400) {
    const errors: UpdateErrors = body.errors;
    errCallback(errors);
  } else if (res.status === 403) {
    forbiddenCallback != undefined && forbiddenCallback();
  }
}